const paragraph = (theme) => ({
  marginTop: theme.spacing(2),
})

export const styles = {
  paragraph,
}
